import React, { useState } from "react";
import { Autocomplete, Chip } from "@mui/material";
import CustomTextField from "../../../../../components/ui/Textfield";

interface KeywordChipInputProps {
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
  placeholder?: string;
  helperText?: string;
}

const KeywordChipInput: React.FC<KeywordChipInputProps> = ({
  label,
  value,
  onChange,
  placeholder,
  helperText,
}) => {
  const [inputValue, setInputValue] = useState("");

  const addPendingKeywords = () => {
    const pendingKeywords = inputValue
      .split(",")
      .map((keyword) => keyword.trim())
      .filter(Boolean);

    if (!pendingKeywords.length) return;

    const existingKeywords = new Set(value.map((keyword) => keyword.toLowerCase()));
    const uniqueKeywords = pendingKeywords.filter((keyword) => {
      const normalized = keyword.toLowerCase();
      if (existingKeywords.has(normalized)) return false;
      existingKeywords.add(normalized);
      return true;
    });

    if (uniqueKeywords.length) onChange([...value, ...uniqueKeywords]);
    setInputValue("");
  };

  return (
    <Autocomplete
      multiple
      freeSolo
      options={[]}
      value={value}
      inputValue={inputValue}
      onInputChange={(_event, newInputValue) => setInputValue(newInputValue)}
      onChange={(_event, newValue) => {
        onChange(
          (newValue as string[])
            .map((keyword) => keyword.trim())
            .filter(Boolean),
        );
        setInputValue("");
      }}
      onBlur={addPendingKeywords}
      renderTags={(tags, getTagProps) =>
        tags.map((tag, index) => (
          <Chip label={tag} size="small" {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) => (
        <CustomTextField
          {...params}
          label={label}
          placeholder={value.length ? undefined : placeholder}
          helperText={helperText}
        />
      )}
    />
  );
};

export default KeywordChipInput;
